import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import moment from "moment";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function KillersCreate() {
  const { user } = useContext(AuthContext);
  const classes = useStyles();
  const URL_KILLERS = process.env.REACT_APP_URL_KILLERS;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_GRUPOS = process.env.REACT_APP_URL_GRUPOS;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState(null);
  const [monto, setMonto] = useState(0);
  const [fechaInicio, setFechaInicio] = useState(hoy);
  const [fechaFin, setFechaFin] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [validaBoton, setValidaBoton] = useState(true);
  const [grupos, setGrupos] = useState([]);
  const [selectedGrupo, setSelectedGrupo] = useState("");

  useEffect(() => {
    axios.get(URL_ARTICULOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setArticulos(res.data))
      .catch(console.log);
    axios.get(URL_GRUPOS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setGrupos(res.data))
      .catch(console.log);
  }, []);

  const saveKiller = (event) => {
    event.preventDefault();
    if (!selectedArticulo) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Selecciona un artículo",
      });
      return;
    }
    setValidaBoton(false);
    axios
      .post(
        URL_KILLERS,
        {
          articulos: selectedArticulo._id,
          monto: parseFloat(monto),
          fechaInicio,
          fechaFin,
          observaciones,
          grupos: selectedGrupo || null,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          {
            tipo: "Crear Killer",
            detalle: `Articulo: ${selectedArticulo.nombre} / Monto: ${monto}`,
            user: user.id,
          },
          {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          }
        );
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => {
          window.location.href = "/ListadoKillers";
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data}`,
        });
        console.log(error);
        setValidaBoton(true);
      });
  };

  return (
    <>
      <Header />
      <br />
      <br />
      {user.ventas_create ? (
        <div className="container">
          <div className="card container col-sm-8">
            <h3 align="center">Nuevo Killer Walmart</h3>
            <Form onSubmit={saveKiller}>
              <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                <Row>
                  <Col md={12}>
                    <Label className="mr-sm-2">Artículo</Label>
                    <Autocomplete
                      size="small"
                      value={selectedArticulo}
                      onChange={(event, newValue) => {
                        setSelectedArticulo(newValue);
                      }}
                      options={articulos}
                      getOptionLabel={(option) =>
                        option.nombre
                          ? `${option.nombre} / ${option.codigo}`
                          : ""
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Selecciona Artículo"
                          variant="outlined"
                        />
                      )}
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={6}>
                    <Label className="mr-sm-2">Monto</Label>
                    <Input
                      type="number"
                      placeholder="Monto"
                      value={monto}
                      required
                      onChange={(e) => setMonto(e.target.value)}
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={6}>
                    <Label className="mr-sm-2">Fecha Inicio</Label>
                    <Input
                      type="date"
                      value={fechaInicio}
                      required
                      onChange={(e) => setFechaInicio(e.target.value)}
                    />
                  </Col>
                  <Col md={6}>
                    <Label className="mr-sm-2">Fecha Fin</Label>
                    <Input
                      type="date"
                      value={fechaFin}
                      required
                      onChange={(e) => setFechaFin(e.target.value)}
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={12}>
                    <Label className="mr-sm-2">Observaciones</Label>
                    <Input
                      type="textarea"
                      placeholder="Observaciones"
                      value={observaciones}
                      onChange={(e) => setObservaciones(e.target.value)}
                    />
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={6}>
                    <Label className="mr-sm-2">Grupo (Walmart)</Label>
                    <Input
                      type="select"
                      value={selectedGrupo}
                      onChange={(e) => setSelectedGrupo(e.target.value)}
                    >
                      <option value="">Todos / Sin filtro</option>
                      {grupos.sort((a,b) => a.name > b.name ? 1 : -1).map((g) => (
                        <option key={g._id} value={g._id}>{g.name}</option>
                      ))}
                    </Input>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col md={6}>
                    <Button
                      type="submit"
                      className="btn btn-success"
                      disabled={!validaBoton}
                    >
                      Guardar
                    </Button>
                  </Col>
                  <Col md={6}>
                    <Button
                      href="/ListadoKillers"
                      className="btn btn-danger"
                      id="botonListado"
                    >
                      Regresar
                    </Button>
                  </Col>
                </Row>
              </FormGroup>
            </Form>
          </div>
        </div>
      ) : (
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-body">
                <h3 align="center">Acceso Denegado</h3>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default KillersCreate;
